import Base from './Base';
import { USER_ROLES } from '../modules/user';

export default class User extends Base {
    constructor(item) {
        super(item);

        if (!this.photo_url) {
            this.photo_url = this.photoUrl;
        }

        if (!this.full_name) {
            this.full_name = this.fullName;
        }

        if (!this.first_name) {
            this.first_name = this.firstName;
        }

        if (!this.last_name) {
            this.last_name = this.lastName;
        }
    }

    get color() {
        const palette = [
            '#6372A5',
            '#1D95F2',
            '#10D0AD',
            '#E13466',
            '#FFC422',
            '#FF9423',
            '#A233E1',
        ];

        return palette[this.id % palette.length];
    }

    get isLoggedIn() {
        return this.id !== 0;
    }

    get isAvatar() {
        return Boolean(this.photo_url);
    }

    get isDefaultAvatar() {
        if (!this.photo_url) return false;

        return this.photo_url.includes(`${window.location.hostname}/images/app/default-avatar.png`);
    }

    get src() {
        if (!this.isAvatar) {
            return false;
        }

        if (this.photo_url.indexOf('gravatar') !== -1) {
            return `${this.photo_url}`;
        }

        return this.photo_url;
    }

    get isOwnerRole() {
        return this.role === USER_ROLES.OWNER;
    }

    get isViewOnlyRole() {
        return this.role === USER_ROLES.VIEW_ONLY;
    }

    get isMemberRole() {
        return this.role === USER_ROLES.MEMBER;
    }

    get isManagerRole() {
        return this.role === USER_ROLES.MANAGER;
    }

    get isAdminRole() {
        return this.role === USER_ROLES.ADMIN;
    }

    get roleLabel() {
        if (this.isViewOnlyRole) {
            return 'Observer';
        }

        if (this.isMemberRole) {
            return 'Member';
        }

        if (this.isManagerRole) {
            return 'Manager';
        }

        if (this.isAdminRole) {
            return 'Admin';
        }

        return 'Owner';
    }
}
